<script>
export default {
  name: "Frame",
  data(){
    return {
        tabs: [
          '/'
        ],
    };
  },
  computed:{
      lang(){
        return {
          tab: {
            untitled: 'Untitled Page'
          },
          contextmenu: {
            refresh: 'Tab aktualisieren',
            refreshAll: 'Alle Tabs aktualisieren',
            close: 'Tab schließen',
            closeLefts: 'Alle Tabs links von diesem schließen',
            closeRights: 'Alle Tabs rechts von diesem schließen',
            closeOthers: 'Alle anderen Tabs schließen'
          },
          msg: {
            keepLastTab: 'Keep at least 1 tab'
          }
        }
      }
  },
  mounted() {
      /*let url = this.$router.resolve({ name: 'offer', params: { id: 79744 } }).href;
      let tab = this.$tabs.matchRoute(url);

      setTimeout(() => {
          console.log(this.$tabs);

          for(let t of this.$tabs.items){
              //console.log(t.id == url, t, url);
              if(t.id == url){
                  t.tabClass = "updated";
                  return;
              }
          }

      },10000);

      console.log(this.$tabs.matchRoute(url), "Test"); */
  },
  methods: {
    titleTanslator(key, params){
      return this.$t(key);
    },
  }
}
</script>

<template>
  <router-tab v-if="$store.state.tab" class="h-100" :i18n="titleTanslator" :tabs="tabs" :lang="lang" :contextmenu="true" :restore="$auth.user().id"  :refresh="true" :keep-alive="true" append="last" restore-watch/>
  <router-view v-else></router-view>
</template>

<style scoped>

</style>